import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CustomBranch } from '@data/custom-branch/custom-branch.model';

export interface CustomBranchState
  extends EntityState<CustomBranch, CustomBranch['_id']>, ActiveState<CustomBranch['_id']> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'custom-branches', resettable: true, idKey: '_id' })
export class CustomBranchStore extends EntityStore<CustomBranchState> {
  constructor() {
    super();
  }
}
